import { Component, OnInit } from '@angular/core';
import { SafePipe } from '../../shared/pipes/safe/safe.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonComponent } from '../../ui/button/button.component';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../ngrx';
import { BaseComponent } from '../../shared/components/base/base.component';
import { takeUntil } from 'rxjs/operators';
import { NgOptimizedImage } from '@angular/common';



@Component({
    selector: 'app-nordic',
    imports: [
        SafePipe,
        TranslateModule,
        ButtonComponent,
        RouterLink,
        NgOptimizedImage
    ],
    templateUrl: './nordic.component.html',
    styleUrls: ['./../website-grid.scss', './../website-pages.scss', './nordic.component.scss']
})
export class NordicComponent extends BaseComponent implements OnInit {
  deviceType: string;

  constructor(
    private _store: Store<IAppState>,
  ) {
    super();
  }

  get currentDeviceType(): string {
    return this.deviceType;
  }

  ngOnInit(): void {
    this._store.select(s => s.ui.device).pipe(
        takeUntil(this.destroy$))
        .subscribe((device) => {
          this.deviceType = device.calculatedDeviceType;
        }
    );
  }
}
